import { render, staticRenderFns } from "./rms-objects-service-tab.vue?vue&type=template&id=7521c82a&scoped=true"
import script from "./rms-objects-service-tab.vue?vue&type=script&lang=js"
export * from "./rms-objects-service-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521c82a",
  null
  
)

export default component.exports